import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jiantou1",
  "use": "icon-jiantou1-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol viewBox=\"0 0 13 13\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-jiantou1\"><g id=\"icon-jiantou1_Frame 24\"><path id=\"icon-jiantou1_è·¯å¾ 2\" d=\"M4.2173 1.16318L9.10354 6.16318C9.27804 6.34175 9.29226 6.61853 9.14565 6.81311L9.10564 6.85993L4.21941 11.9208L3.5 11.2262L8.04915 6.51514L3.50211 1.8621L4.2173 1.16318Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol